import formSelect from '../modules/form';
import 'select2';

$(document).ready(function () {
    formSelect();
});



// WEBPACK FOOTER //
// ./app/Resources/assets/default/js/hr/hr.js